const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/home/index.vue'),
  },
  // 旅行婚礼酒店全景
  {
    path: '/travel',
    name: 'travel',
    component: () => import('@/views/travel/index.vue'),
  },
  // 旅行婚礼酒店全景-场地对比
  {
    path: '/place_compare',
    name: 'place_compare',
    component: () => import('@/views/place_compare/index.vue'),
  },
  // 场部全景
  {
    path: '/goods',
    name: 'goods',
    component: () => import('@/views/goods/index.vue')
  },
  // 海外酒店布置全景(goods换了UI)
  {
    path: '/abroad_goods',
    name: 'abroad_goods',
    component: () => import('@/views/abroad_goods/index.vue')
  },
  // 诸葛app全景
  {
    path: '/inside',
    name: 'inside',
    component: () => import('@/views/inside/pano/index.vue'),
  },
  // 诸葛app场部全景
  {
    path: '/inside/goods',
    name: 'insideGoods',
    component: () => import('@/views/inside/goods/index.vue')
  },
  // 门店全景
  {
    path: '/store',
    name: 'store',
    component: () => import('@/views/store/index.vue')
  },
  {
    path: '/test',
    name: 'test',
    component: () => import('@/views/test/index.vue'),
  },
  { path: '/:noMatch(.*)', redirect: { name: 'home' } },
]

export default routes
